export const AUTH_CONFIG = {
  domain: "nickcannariato.auth0.com",
  clientId: "tBTudXB9QQ9EfcHHlxBoQCa9OJ5uObC7",
  callbackUrl: process.env.REACT_APP_LOCAL || process.env.REACT_APP_PROD
  //=callbackUrl: "http://localhost:3000/callback"
};
